<template>
  <v-card title="Access Control">
    <v-tabs v-model="tabIndex" left>
      <v-tab>Roles</v-tab>
      <v-tab>Permission</v-tab>
      <v-tab>Routes</v-tab>    
    </v-tabs>
    <v-divider/>
    <v-tabs-items v-model="tabIndex">
      <v-tab-item><component v-bind:is="'tab-roles'" /> </v-tab-item>
      <v-tab-item><component v-bind:is="'tab-permission'" /></v-tab-item>
      <v-tab-item><component v-bind:is="'tab-routes'"/></v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import TabRoles      from './roles'
import TabPermission from './permission'
import TabRoutes     from './routes'

export default {
  components : {TabRoles, TabPermission,TabRoutes},
  data : ()=>({tabIndex : 0}),
}
</script>

<style lang="scss">
  .data-table-server-pagination---avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
</style>
